












































import { Component, Vue, Prop } from "vue-property-decorator";
import { clearFilter } from "@/utils/base";
import { LoginOut } from "@/request/common";
@Component({})
export default class Login extends Vue {
  private size: any = "大";
  private get user() {
    return this.$store.state.user;
  }
  private get href() {
    return window.location.href;
  }
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get system() {
    return this.$store.state.system;
  }
  private changeSize() {
    if (this.size == "大") {
      document.documentElement.style.setProperty("--bigSize", "30px");
      document.documentElement.style.setProperty("--h1Size", "22px");
      document.documentElement.style.setProperty("--h2Size", "20px");
      document.documentElement.style.setProperty("--h3Size", "18px");
      document.documentElement.style.setProperty("--mainSize", "16px");
      document.documentElement.style.setProperty("--miniSize", "14px");
    } else if (this.size == "小") {
      document.documentElement.style.setProperty("--bigSize", "28px");
      document.documentElement.style.setProperty("--h1Size", "20px");
      document.documentElement.style.setProperty("--h2Size", "18px");
      document.documentElement.style.setProperty("--h3Size", "16px");
      document.documentElement.style.setProperty("--mainSize", "14px");
      document.documentElement.style.setProperty("--miniSize", "12px");
    }
  }
  private goRouter(item: any) {
    if (!item.path) {
      return;
    }
    this.$store.commit("updatePatient", null);
    clearFilter();
    this.$router.push(item.path);
  }
  /**
   * @description 点击切换账号
   */
  private handleCommand(command: any) {
    if (command === "退出登录") {
      this.$message.success("退出成功");
      this.$store.commit("updateToken", "");
      this.$store.commit("updateUser", "");
      this.$router.push("/access/login");
      return;
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      LoginOut(this, loading)
        .then(() => {
          loading.close();
          this.$message.success("退出成功");
          this.$store.commit("updateToken", "");
          this.$router.push("/access/login");
        })
        .catch(() => {
          loading.close();
        });
    }
  }
  /**
   * @description 切换系统
   */
  private handleXitong(command: any) {
    this.$store.commit("updateToken", "");
    this.$store.commit("updateUser", "");
    if (command === "跳转用户端") {
      this.$store.commit("updateSystem", "用户端");
      this.$router.replace("/home/folder");
    } else if (command === "跳转管理端") {
      this.$store.commit("updateSystem", "管理端");
      this.$router.replace("/access/login");
    }
  }
  private mounted() {
    // this.changeSize();
  }
}
